<script setup lang="ts">
interface Props {
  company: string;
}

interface Emits {
  (e: 'update:company', value: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="space-y-5">
    <div>
      <label for="company" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_company.company_label') }}
      </label>
      <input
        type="text"
        id="company"
        required
        :value="company"
        @input="emit('update:company', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_company.company_placeholder')"
      />
    </div>
  </div>
</template>
